import Bowser from "bowser";
import dayjs from "dayjs";
import { parsePhoneNumber } from "libphonenumber-js";
import { useEffect, useRef, useState } from "react";
import { LoyaltyMember } from "screens/restaurant/reataurant-card";
import { JoinMemberMode } from "types/joinAsMemberMode";

// 重置路由状态 + 刷新整个页面
export const resetRoute = () => (window.location.href = window.location.origin);

/**
 * 返回组件的挂载状态，如果还没挂载，或 已经卸载，返回false；否则，返回true
 */
export const useMountedRef = () => {
  const mountedRef = useRef(false);
  useEffect(() => {
    // 挂载成功，是true
    mountedRef.current = true;
    // 卸载
    return () => {
      mountedRef.current = false;
    };
  });
  return mountedRef;
};

export const useWindowSize = () => {
  const isSSR = typeof window == "undefined";
  const [windowSize, setWindowSize] = useState({
    width: isSSR ? 1200 : window.innerWidth,
    height: isSSR ? 800 : window.innerHeight,
  });

  function changeWindowSize() {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }

  useEffect(() => {
    window.addEventListener("resize", changeWindowSize);

    return () => {
      window.removeEventListener("resize", changeWindowSize);
    };
  }, []);

  return windowSize;
};

export const getBrowserType = () => {
  const BrowserInfo = Bowser.parse(window.navigator.userAgent);
  return {
    browserName: BrowserInfo.browser.name || "Safari",
    osName: (BrowserInfo.os.name || "ios").toLocaleLowerCase(),
  };
};

export const formatCountAndBack = (value: string) => {
  return Math.floor(parseFloat(value) * 100);
};

export const slicePhoneNumber = (value: string) => {
  const len = value.length;
  return value.length > 4 ? value.slice(len - 4, len) : value;
};

export const getFormatNumber = (phoneNumber: string) => {
  const obj = parsePhoneNumber(phoneNumber, "US");
  return obj?.number || "";
};

export function isLoyaltyMemberExpired(loyaltyMemberInfo: LoyaltyMember) {
  let memberId = loyaltyMemberInfo.memberId;
  let expirationDate = loyaltyMemberInfo.expirationDate;
  if (expirationDate && memberId) {
    return dayjs(expirationDate, 'MM/DD/YYYY').isBefore(dayjs(new Date()), 'date')// => boolean
  }
  return false;
}


export function getLoyaltyMemberJoinStatus(loyaltyMember: LoyaltyMember, disountData: any) {
  if (!loyaltyMember) {
    return {
      isFressJoinAsMemberModel: true,
      joinMemberMode: JoinMemberMode.free_join,
      memberIsActive: false,
      memberExpired: false,
      rechargeJoinModeActived: false,
      annualJoinModeExpiredActived: false,
      annualJoinModeActived: false,
    };
  }
  let exppired = isLoyaltyMemberExpired(loyaltyMember);
  let { memberIsActive } = loyaltyMember;
  let isFressJoinAsMemberModel = (disountData.join_member_mode || JoinMemberMode.free_join) ===
    JoinMemberMode.free_join; //annual_fee_join,recharge_join,free_join
  const join_member_mode = disountData.join_member_mode || JoinMemberMode.free_join;
  return {
    isFressJoinAsMemberModel,
    joinMemberMode: join_member_mode,
    memberIsActive,
    memberExpired: exppired,
    annualFeeAmount: disountData.annual_fee_amount,
    annualFeeDealId: disountData.annual_fee_deal_id,
    rechargeJoinModeActived: join_member_mode === JoinMemberMode.recharge_join && !memberIsActive,
    annualJoinModeActived: join_member_mode === JoinMemberMode.annual_fee_join && !memberIsActive,
    annualJoinModeExpiredActived: join_member_mode === JoinMemberMode.annual_fee_join && (memberIsActive && exppired),
  }
}



export function IS_NOT_Undefined_Null(value: any) {
  if (value !== undefined && value !== null) {
    return true;
  }
  return false;
}